import { PATH_LOGIN } from "@routes/paths";
import AuthQuote from "@components/auth/auth.quote";
import AuthLogo from "@components/auth/auth.logo";
import { Link } from "react-router-dom";
import ForgotPasswordForm from "./forgot.password.form";

const ForgotPasswordContainer = () => {
  return (
    <div className="grid lg:grid-cols-2 min-h-screen">
      <div className="w-full h-full bg-gray-100 p-10 lg:p-20">
        <div className="mx-auto max-w-sm">
          <AuthLogo />
          <h3 className="text-black font-bold text-center text-dark text-xl md:text-2xl">Reset Password</h3>

          <div className="text-black text-center text-sm mb-5 px-10">
            To reset your password please enter your <b>email address</b>
          </div>
          <ForgotPasswordForm />
          <p className="text-sm text-gray-900 text-center mt-3">
            <Link to={PATH_LOGIN} className="text-black hover:underline">
              Cancel
            </Link>
          </p>
        </div>
      </div>
      <AuthQuote />
    </div>
  );
};

export default ForgotPasswordContainer;
